/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-12-29 14:42:11
 * @FilePath: /mall-fe/src/views/web/home/NewIndex/components/MinHeader.tsx
 * @Description: 商城新版门户首页头部组件
 *
 */
/* eslint-disable react/jsx-no-target-blank */
import { Modal } from 'antd';
import Container from 'comps/Container';
import HeaderDropdown from 'comps/HeaderDropdown';
import IconTel from 'icons/tel.svg';
// import IconQuestion from 'icons/question.svg';
import ImgTopQRNew from 'images/cscec3b/menu-qr-new.jpg';
// import { ENABLE_SUPPLY_CHAIN } from 'libs/cons';
import { SiteContext, UserContext } from 'libs/contexts';
import { API_SSO, HELP_CENTER_URL_PREFIX } from 'libs/urls';
import Link from 'next/link';
import { useCallback, useContext, useEffect, useState } from 'react';
import { authApplicationChange, checkAuthentication, getSmartSettlementAuthCode } from 'api/user';
import { CurrentUserTypeSource } from 'libs/enums';
import { getContainerName } from 'libs/dopUtil.js';
// import { amI } from '@/libs/user';
// import IsExternalPurchaserUsed from '@/views/h5/my-center/shared/hooks/useIsExternalPurchaserUsed';
// import SelfOperatedOrganization from '@/views/h5/my-center/features/settlement/hooks/useSelfOperatedOrganization';
// import HotIcon from 'images/cscec3b/index/hot.png';
import ServiceIcon from '@/images/cscec3b/home/service-icon.png';
import ComputeIcon from '@/images/cscec3b/home/compute.png';
import AvatarIcon from '@/images/cscec3b/home/avatar.png';
import QianbiIcon from '@/images/cscec3b/home/qianbi.png';

export default function MiniHeader() {
  const userInfo = useContext(UserContext);
  const site = useContext(SiteContext);
  // const runtimeConfig = useContext(RuntimeConfigurationContext);
  // 推出二次确认
  const [visible, setVisible] = useState(false);
  const [portalURL, setPortalURL] = useState<string>('/portal/');
  // 个人实名认证弹窗
  const [authenticationVisible, setAuthenticationVisible] = useState<boolean>(false);
  // 判断是否内嵌DOP
  const [isInDop, setIsInDop] = useState(false);
  // const canChangeRole = userInfo?.applications?.find((item) => item.key !== 'personal') || false;
  // const supplyChainEnabled = runtimeConfig?.some(
  //   ({ domain, key, value }) =>
  //     domain === 'runtime' && key === ENABLE_SUPPLY_CHAIN && value === '1',
  // );
  // const isSupplier = amI(userInfo, 'supplier');
  // const selfOperatedOrganization = SelfOperatedOrganization();
  // const canShowEnquiryList = !selfOperatedOrganization && (IsExternalPurchaserUsed() || isSupplier);

  const checkDopInfo = async () => {
    try {
      const dopContainerName = await getContainerName();
      console.warn('check header.', dopContainerName);
      setIsInDop(dopContainerName === 'DOP_PORTAL');
    } catch (e) {
      console.error('get container name error.');
    }
  };

  useEffect(() => {
    checkDopInfo();
  }, []);

  useEffect(() => {
    if (userInfo?.currentUserType === CurrentUserTypeSource.personal) {
      setPortalURL(`/portal?perferKey=personal`);
    }
  }, [userInfo]);

  // 登录跳转
  // const handleLogin = useCallback(() => {
  //   if (site?.hasEgo) {
  //     const fgfHost = runtimeConfig.find((item) => item.key === 'fgfHostHttpUrl')?.value ?? '';
  //     location.href = `${fgfHost}/sso/xlogin?return_url=${encodeURIComponent(location.href)}`;
  //   } else {
  //     location.href = `/sso/xlogin?return_url=${encodeURIComponent(location.href)}`;
  //   }
  // }, [runtimeConfig, site?.hasEgo]);

  // 登出弹窗
  const handleLogOut = useCallback(() => {
    setVisible(true);
  }, []);

  // 关闭登出弹窗
  const hideModal = useCallback(() => {
    setVisible(false);
  }, []);

  // 登出确认
  const confirmModal = useCallback(() => {
    // 退出登录后回到首页
    location.href = `/${API_SSO}/logout?source=mall&return_url=${encodeURIComponent(
      location.origin,
    )}`;
    hideModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toHelpCenter = async () => {
    let linkUrl = `${HELP_CENTER_URL_PREFIX}/helpCenterJumpPage?code=`;
    if (userInfo && userInfo.name) {
      const { data = {} } = await getSmartSettlementAuthCode('cscec3_yun_cai');
      linkUrl = `${linkUrl}${data?.authCode || ''}`;
    }
    window.selfOpen(linkUrl, '_blank');
  };
  /**
   * 切换当前用户身份
   */
  const authChange = async (roleType: number) => {
    const res = await authApplicationChange(roleType);
    if (res.data) {
      window.location.reload();
    }
  };
  /**
   * 当前用户是个人，直接切换至企业
   * 当前是企业，需要先看是否实名认证，是则切换，否则弹窗
   */
  const changeRole = async (e) => {
    e.preventDefault();
    const isPerson = userInfo.currentUserType === CurrentUserTypeSource.personal;
    const { sysNo } = userInfo || {};
    if (isPerson) {
      authChange(-1);
    } else {
      const res = await checkAuthentication(sysNo);
      if (res?.data) {
        authChange(54);
      } else {
        setAuthenticationVisible(true);
      }
    }
  };
  return isInDop ? null : (
    <div className="head">
      <Container>
        <div className="head-box">
          <div className="item-center">
            <Link href={'/'}>
              <a className="platform-link" title="平台首页">
                平台首页
              </a>
            </Link>
            <span className="sep" />
            <span className="contact">
              客服电话：
              <a style={{ color: '#bbb' }} href="tel:0711-5900818">
                0711-5900818
              </a>
            </span>
            <span className="sep" />
            <span className="contact">
              客服邮箱：
              <a style={{ color: '#bbb' }} href="mailto:ycgyl-kf@cscec.com">
                ycgyl-kf@cscec.com
              </a>
            </span>
          </div>

          <div className="head-right">
            {!site?.hasEgo && (
              <span className="qr-container">
                <IconTel /> 手机三局严选
                <i className="iconfont icon-dropdown" />
                <img className="top-qr" src={ImgTopQRNew} alt="二维码" />
              </span>
            )}
            <a href={`/yf-shop`} className="yf">
              <span>严选优服</span>
            </a>
            <span className="sep" />
            {!!userInfo?.isSupplier && (
              <>
                <a href={`/pages/extra-serve`} target="_blank">
                  <span style={{ cursor: 'pointer' }}>
                    <img src={ServiceIcon} alt="" style={{ height: '20px' }} />
                    {/* 增值权益专区 */}
                  </span>
                </a>
                <span className="sep" />
              </>
            )}
            <span>
              <a
                className="financial-zone"
                href={`/pages/financial-zone`}
                title="金融专区"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={QianbiIcon} alt="" style={{ height: '14px', marginRight: '2px' }} />
                金融专区
              </a>
            </span>
            <span className="sep" />
            <span>
              <a className="help-center" title="帮助中心" onClick={toHelpCenter}>
                {/* <IconQuestion style={{ marginBottom: '-3px' }} /> */}
                <i
                  className="iconfont icon-question1"
                  style={{ verticalAlign: 'middle', marginRight: '2px' }}
                />
                帮助中心
              </a>
            </span>

            {!!userInfo && (
              <>
                <span className="sep" />
                <span>
                  <a className="help-center" href={portalURL} title="工作台" target="_top">
                    <img src={ComputeIcon} alt="" style={{ height: '14px', marginRight: '2px' }} />
                    工作台
                  </a>
                </span>
              </>
            )}

            {!!userInfo && (
              <>
                <span className="sep" />
                您好，
                <HeaderDropdown
                  arrowType="svg"
                  className="user"
                  title={userInfo.name}
                  showArrow
                  as="a"
                  href="/portal/"
                >
                  <div className="dropdown-content">
                    <div className="text" key="1">
                      <div
                        style={{
                          padding: '12px 0 10px',
                          borderBottom: '1px solid #e9eff4',
                          marginBottom: '12px',
                        }}
                      >
                        <img src={AvatarIcon} alt="用户头像" />
                        <span style={{ marginLeft: '8px' }}>{userInfo.name}</span>
                      </div>
                    </div>
                    <p className="text" key="2">
                      <a className="link" href="/sso/user" target="_top">
                        <i className="iconfont icon-Frame" />
                        <span style={{ marginLeft: '8px' }}>账号信息</span>
                      </a>
                    </p>
                    {/* {!!canShowEnquiryList && (
                      <p className="text">
                        <Link href={'/enquiry/list'}>
                          <a className="link" title="我的询价">
                            我的询价
                          </a>
                        </Link>
                      </p>
                    )} */}
                    <p className="text" key="3">
                      <a className="link" href="/sso/change/password" target="_top">
                        <i className="iconfont icon-a-Frame1" />
                        <span style={{ marginLeft: '8px' }}>修改密码</span>
                      </a>
                    </p>
                    <p className="text" key="4">
                      <a className="link" title="退出" onClick={handleLogOut}>
                        <i className="iconfont icon-a-Frame2" />
                        <span style={{ marginLeft: '8px' }}>退出</span>
                      </a>
                    </p>
                  </div>
                </HeaderDropdown>
              </>
            )}
            {/* {
              userInfo?.isInside && (
                <>
                  <span className="sep"></span>
                  <a className="help-center" title="回到旧版" onClick={toOldHome}>
                    回到旧版
                  </a>
                </>
              ) 
            } */}
            {/* {canChangeRole && (
              <>
              <span className="sep" />
              <a className="change-role" title={null} onClick={(e) => changeRole(e)}>
                {userInfo.currentUserType !== CurrentUserTypeSource.personal
                  ? '切换至个人版'
                  : '切换至企业版'}
              </a>
              </>
            )} */}
          </div>
        </div>
      </Container>
      <Modal
        title="提示"
        width="400px"
        visible={visible}
        onOk={confirmModal}
        onCancel={hideModal}
        okText="确认"
        cancelText="取消"
        maskClosable={false}
      >
        <p>您确定退出系统吗？</p>
      </Modal>
      <Modal
        title="提示"
        width="500px"
        visible={authenticationVisible}
        onOk={() => {
          window.location.href = '/sso/authentication?isChange=true';
        }}
        onCancel={() => {
          setAuthenticationVisible(false);
        }}
        okText="实名认证"
        cancelText="取消"
        maskClosable={false}
      >
        <p>
          您需要进行实名认证，认证后可使用个人角色来购物，个人角色仅本人可见，企业组织不能获取您的个人购物记录
        </p>
      </Modal>
      <style jsx>{`
        .item-center {
          display: flex;
          align-items: center;
        }
        .head {
          width: 100%;
          height: 32px;
          background-color: #333;
          border-bottom: 1px solid #f1f1f1;
        }
        .head-box {
          width: 100%;
          height: 32px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .platform-link {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #bbb;
        }
        .help-center {
          line-height: 20px;
          font-size: 12px;
          color: #bbb;
          display: flex;
          align-items: center;
        }
        .financial-zone {
          line-height: 20px;
          font-size: 12px;
          color: #f7db92;
          display: flex;
          align-items: center;
        }
        .financial-zone img {
          filter: brightness(0) saturate(100%)
            invert(90%) sepia(28%) saturate(650%)
            hue-rotate(348deg) brightness(103%) contrast(94%);
        }
        .platform-link:hover, .help-center:hover {
          color: ${site?.global?.platformMainColor};
        }
        .financial-zone:hover {
          color: #f7db92;
        }
        .head-right {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #bbb;
        }
        .head-right :global(.dropdown) {
          display: inline-block;
          vertical-align: top;
        }
        .head-right :global(.user) :global(.title) {
          font-size: 12px;
          color: #bbb;
        }
        .head-right :global(.help) :global(.title) {
          font-size: 12px;
          color: #bbb;
        }
        .head-right :global(.help) :global(.icon) {
          border-top-color: #bbb;
        }
        .sep {
          display: inline-block;
          margin: 0 12px;
          border-right: 1px solid #999;
          height: 12px;
          vertical-align: middle;
        }

        .login,
        .reg {
          margin-left: 10px;
        }
        .login {
          color: #bbb;
        }
        .reg {
          color: ${site?.global?.platformMainColor};
        }

        .login:hover,
        .reg:hover,
        .about:hover {
          color: ${site?.global?.platformMainColor};
          text-decoration: none;
        }
        .yf {
          color: #bbb;
        }
        .yf:hover {
          color: ${site?.global?.platformMainColor};
        }
        .head-right {
          // float: right;
          height: 32px;
          margin-bottom: 0;
        }
        .head-right li {
          display: inline-block;
          vertical-align: top;
          margin-top: 6px;
          line-height: 20px;
          margin-left: 30px;
        }
        .about {
          color: #474747;
        }

        .qr-container {
          position: relative;
          display: inline-flex;
          align-items: center;
          padding-right: 18px;
          border-right: 1px solid #999;
          margin-right: 14px;
          height: 12px;
          vertical-align: middle;
          cursor: default;
          user-select: none;
        }
        .qr-container :global(svg) {
          margin-right: 4px;
          transform: translateY(-1px);
        }
        .top-qr {
          display: none;
          position: absolute;
          top: 100%;
          right: 10px;
          width: 421px;
          height: 175px;
          z-index: 10;
        }
        .qr-container:hover .top-qr {
          display: block;
        }
        .contact {
          color: #bbb;
          line-height: 32px;
          font-size: 12px;
        }
        .change-role {
          line-height: 20px;
          font-size: 12px;
          color: #bbb;
        }
        .change-role :hover {
          color: ${site?.global?.platformMainColor};
        }
      `}</style>
      <style jsx>{`
        .dropdown-content {
          width: auto;
          height: auto;
          margin-top: 4px;
          border-radius: 2px;
          box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
          background-color: #fff;
          padding: 5px 0;
          text-align: left;
          position: relative;
          top: 2px;
        }
        .dropdown-content :global(.text) {
          line-height: 27px;
          font-size: 12px;
          color: #000;
          padding: 0 16px;
          white-space: nowrap;
          margin-bottom: 0;
          text-align: left;
        }
        .dropdown-content :global(.text a) {
          font-size: 12px;
          color: #000;
        }
        .dropdown-content :global(.text:hover a) {
          color: ${site?.global?.platformMainColor};
        }
        .head-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 3px;
        }

        .head-icon :global(svg) {
          display: inline-block;
          width: 16px;
          height: 16px;
          top: 2px;
          position: relative;
        }
        .svg-icon :global(svg) :global(path) {
          fill: #8c8d8d;
        }
        .dropdown-content :global(.link) {
          display: inline-block;
          width: 100%;
          font-size: 12px;
          color: #000;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}
